__turbopack_context__.v({
  "about": "public-profile-module__RpcgCa__about",
  "actions": "public-profile-module__RpcgCa__actions",
  "below": "public-profile-module__RpcgCa__below",
  "bio": "public-profile-module__RpcgCa__bio",
  "caseText": "public-profile-module__RpcgCa__caseText",
  "contacts": "public-profile-module__RpcgCa__contacts",
  "currentWork": "public-profile-module__RpcgCa__currentWork",
  "dialog": "public-profile-module__RpcgCa__dialog",
  "dialogClose": "public-profile-module__RpcgCa__dialogClose",
  "disclosure": "public-profile-module__RpcgCa__disclosure",
  "emptyResults": "public-profile-module__RpcgCa__emptyResults",
  "error": "public-profile-module__RpcgCa__error",
  "external": "public-profile-module__RpcgCa__external",
  "eyebrow": "public-profile-module__RpcgCa__eyebrow",
  "filterControls": "public-profile-module__RpcgCa__filterControls",
  "focusCard": "public-profile-module__RpcgCa__focusCard",
  "focusLinks": "public-profile-module__RpcgCa__focusLinks",
  "footer": "public-profile-module__RpcgCa__footer",
  "friendButton": "public-profile-module__RpcgCa__friendButton",
  "gallery": "public-profile-module__RpcgCa__gallery",
  "galleryControls": "public-profile-module__RpcgCa__galleryControls",
  "greeting": "public-profile-module__RpcgCa__greeting",
  "handle": "public-profile-module__RpcgCa__handle",
  "headerLabel": "public-profile-module__RpcgCa__headerLabel",
  "hero": "public-profile-module__RpcgCa__hero",
  "heroCopy": "public-profile-module__RpcgCa__heroCopy",
  "iconButton": "public-profile-module__RpcgCa__iconButton",
  "lead": "public-profile-module__RpcgCa__lead",
  "loading": "public-profile-module__RpcgCa__loading",
  "main": "public-profile-module__RpcgCa__main",
  "materialLinks": "public-profile-module__RpcgCa__materialLinks",
  "messageChoices": "public-profile-module__RpcgCa__messageChoices",
  "milestone": "public-profile-module__RpcgCa__milestone",
  "milestoneBody": "public-profile-module__RpcgCa__milestoneBody",
  "milestoneHint": "public-profile-module__RpcgCa__milestoneHint",
  "mobileShare": "public-profile-module__RpcgCa__mobileShare",
  "motionButton": "public-profile-module__RpcgCa__motionButton",
  "muted": "public-profile-module__RpcgCa__muted",
  "navigation": "public-profile-module__RpcgCa__navigation",
  "notice": "public-profile-module__RpcgCa__notice",
  "online": "public-profile-module__RpcgCa__online",
  "page": "public-profile-module__RpcgCa__page",
  "position": "public-profile-module__RpcgCa__position",
  "privacy": "public-profile-module__RpcgCa__privacy",
  "projectCard": "public-profile-module__RpcgCa__projectCard",
  "projectCover": "public-profile-module__RpcgCa__projectCover",
  "projectDescription": "public-profile-module__RpcgCa__projectDescription",
  "projectGrid": "public-profile-module__RpcgCa__projectGrid",
  "projectMeta": "public-profile-module__RpcgCa__projectMeta",
  "projectPreview": "public-profile-module__RpcgCa__projectPreview",
  "projectRole": "public-profile-module__RpcgCa__projectRole",
  "projectTitle": "public-profile-module__RpcgCa__projectTitle",
  "publications": "public-profile-module__RpcgCa__publications",
  "related": "public-profile-module__RpcgCa__related",
  "resetTopic": "public-profile-module__RpcgCa__resetTopic",
  "resumeProjects": "public-profile-module__RpcgCa__resumeProjects",
  "secondary": "public-profile-module__RpcgCa__secondary",
  "section": "public-profile-module__RpcgCa__section",
  "sectionBar": "public-profile-module__RpcgCa__sectionBar",
  "skills": "public-profile-module__RpcgCa__skills",
  "skip": "public-profile-module__RpcgCa__skip",
  "state": "public-profile-module__RpcgCa__state",
  "storyDetails": "public-profile-module__RpcgCa__storyDetails",
  "timeline": "public-profile-module__RpcgCa__timeline",
  "topicButton": "public-profile-module__RpcgCa__topicButton",
  "topicButtons": "public-profile-module__RpcgCa__topicButtons",
  "topicDescription": "public-profile-module__RpcgCa__topicDescription",
  "topicExplorer": "public-profile-module__RpcgCa__topicExplorer",
  "topicHint": "public-profile-module__RpcgCa__topicHint",
  "topicResults": "public-profile-module__RpcgCa__topicResults",
  "workTime": "public-profile-module__RpcgCa__workTime",
});
